import { render, staticRenderFns } from "./VideoPublish.vue?vue&type=template&id=e27d7f78&scoped=true"
import script from "./VideoPublish.vue?vue&type=script&lang=js"
export * from "./VideoPublish.vue?vue&type=script&lang=js"
import style0 from "./VideoPublish.vue?vue&type=style&index=0&id=e27d7f78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27d7f78",
  null
  
)

export default component.exports